import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-home-dashboard-skeleton',
  templateUrl: './home-dashboard-skeleton.component.html',
  styleUrls: ['./home-dashboard-skeleton.component.scss']
})
export class HomeDashboardSkeletonComponent {
  @Input() variant: 'schedule' | 'applicant' | 'kpis' = 'schedule';
  readonly tiles = [0, 1, 2, 3];
  readonly rows = [0, 1, 2];
  readonly tasks = [0, 1, 2, 3];
}
